<template>
  <div class="container" v-if="viewContent && viewContent.categories && viewContent.categories.length > 0">
    <div v-for="category in viewContent.categories" :key="category.id">
      <h3>{{category.title}}</h3>
      <h5 v-if="category && category.apps && category.apps.length > 0">{{category.short_desc}}</h5>
      <h5 v-else>You have not set any favorite apps yet</h5>
      <tile-container :apps="category.apps" :category="category" :view="viewContent"></tile-container>
    </div>
  </div>
  <div v-else>
    <div class="container no-content-container">
      <div class="row">
        <div class="col-12">
          <h4>There are no active categories for this view.</h4>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  mapGetters,
  mapActions
} from 'vuex'

import TileContainer from '@/components/TileContainer'

export default {
  name: 'MyFavorites',
  components: {
    TileContainer
  },
  data: function () {
    return {
      viewContent: null
    }
  },
  watch: {
    $route (to, from) {
      this.updateViewData(to.params.pathMatch)
    }
  },
  computed: {
    ...mapGetters(['getViewType', 'getApplications'])
  },
  mounted () {
    this.updateViewData()
  },
  methods: {
    ...mapActions(['retrieveViewFromRoute', 'addAlert']),
    updateViewData () {
      let favorites = this.getApplications.filter( (app) =>{
        return app.isFavorite
      })
      
      // Sort favorites alphabetically
      favorites.sort( (a,b) =>{
        let titleA = a.title.toUpperCase()
        let titleB = b.title.toUpperCase()
        if (titleA < titleB) {
          return -1;
        }
        if (titleA > titleB) {
          return 1;
        }
      })

      this.viewContent = {
        "id": "favorites_view",
        "title": "My Favorites",
        "short_desc": "Company wide resources for Autodesk employees",
        "active": true,
        "order": 0,
        "categories": [
          {
            "id": "favorites_category",
            "title": "My Favorites",
            "short_desc": "Your favorite applications",
            "order": 0,
            "apps": favorites
          }
        ]
      }
    }
  }
}
</script>
<style scoped>
.no-content-container {
  margin-top: 20px;
}
</style>